import { useEffect } from 'react';
import '../styles/petalos.css'

const Petalos = () => {
  useEffect(() => {
    const interval = setInterval(() => {
      const petalo = document.createElement('div');
      petalo.className = 'petalo';
      petalo.innerText = '🌸'; // Puedes cambiar esto por una imagen si quieres
      petalo.style.left = `${Math.random() * 100}vw`;
      petalo.style.animationDuration = `${5 + Math.random() * 5}s`;
      petalo.style.opacity = Math.random() * 0.6 + 0.4;
      petalo.style.fontSize = `${Math.random() * 10 + 15}px`;

      document.body.appendChild(petalo);

      petalo.addEventListener('animationend', () => {
        petalo.remove();
      });
    }, 300); // cada 300 ms cae un pétalo nuevo

    return () => clearInterval(interval); // limpiar cuando se desmonta
  }, []);

  return null;
};

export default Petalos;